import { render, staticRenderFns } from "./DetailsTournament.vue?vue&type=template&id=438eecb7&scoped=true"
import script from "./DetailsTournament.vue?vue&type=script&lang=js"
export * from "./DetailsTournament.vue?vue&type=script&lang=js"
import style0 from "./DetailsTournament.vue?vue&type=style&index=0&id=438eecb7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438eecb7",
  null
  
)

export default component.exports